import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OdsService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getOds(): Observable<any> {
    return this.http.get(this.baseUrl + 'revOdsActivos', { headers: this.header(this.token) });
  }
  getOdsActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'revOdsActivos', { headers: this.header(this.token) });
  }

  getOdsById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'revOds/' + id, { headers: this.header(this.token) });
  }

  postOds(Ods: any): Observable<any> {
    return this.http.post(this.baseUrl + 'revOds', Ods, { headers: this.header(this.token) });
  }

  putOds(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'revOds', bodyString, { headers: this.header(this.token) });
  }

  deleteOds(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'revOds/' + id, { headers: this.header(this.token) });
  }

  getParametricas(): Observable<any> {
    return this.http.get(this.baseUrl + 'permisosActivos', { headers: this.header(this.token) });
  }

  putPermiso(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putPermiso', bodyString, { headers: this.header(this.token) });
  }

}